module.exports = __webpack_public_path__ + "img/image-18.4f212ac9.jpg";